import { render } from "./OthersContainer.vue?vue&type=template&id=665571b6&ts=true"
import script from "./OthersContainer.vue?vue&type=script&lang=ts"
export * from "./OthersContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__